// import { createFile } from 'mp4box';
// import * as MP4Box from 'mp4box';
import CryptoJS from 'crypto-js';

var MP4Box = require('mp4box'); // eslint-disable-line

// For calculating media type
const interlacedHeight_480 = '480';
const interlacedHeight_1080 = '1080';
const interlacedWidth_720 = '720';
const interlacedWidth_1920 = '1920';
const interlacedWidth_1440 = '1440';
const interlacedFPS = '29.97';

const interlaced = 'Interlaced';
const progressive = 'Progressive';

function GetVideoMediaType(width: string, height: string, fps: string) {
  let result = progressive;

  // For our purposes, these values represent interlaced video
  if (((height === interlacedHeight_480 && width === interlacedWidth_720)
    || (height === interlacedHeight_1080 && width === interlacedWidth_1920)
    || (height === interlacedHeight_1080 && width === interlacedWidth_1440)) && fps === interlacedFPS) {
    result = interlaced;
  }

  return result;
}

// TODO: left here, join this logic with logic from getSha1...
export function checkFile(fileStream: File, isVideo: boolean, ignoreVideoCalculations = false, progressUpdateCallback: (stage: string, progressPercentage: string) => void = null): Promise<any> {
  return new Promise((resolve, reject) => {
    try {
      const sz = fileStream.size;
      let offset = 0;
      const block = 1024 * 1024;
      const maxReaders = 5;
      let processed = 0;
      const readerMap: Map<FileReader, number> = new Map();
      let lastOffset = 0;
      let lastPct = 0;
      const hash = CryptoJS.algo.SHA1.create();
      let nextReaderBlock = 0;

      let mp4boxfile: any = null;

      let gopSize = 0;
      let maxGop = 0;
      let runningSamps = 0;
      let ok = true;
      let fileInfo: any = null;

      function onReady(info: any) { fileInfo = info; } // Now dig into the samples...

      function onError(e: any) { reject(e); }

      if (isVideo && !ignoreVideoCalculations) {
        mp4boxfile = MP4Box.createFile(false);
        mp4boxfile.onError = onError;
        mp4boxfile.onReady = onReady;
      }

      function retryRead(stream: any, off: any, rdr: any) {
        // Don't let the reader get too far ahead of the slicer...
        if (off - processed > block * 5) {
          setTimeout(() => retryRead(stream, off, rdr), 50);
        } else {
          const slice = stream.slice(off, off + block);
          rdr.readAsArrayBuffer(slice);
          const pct = off * 100.0 / stream.size;
          if (pct - lastPct > 1) {
            console.log(`[QA] SHA1 ${stream.name} ${pct.toFixed(0)}% complete`);
            if (progressUpdateCallback) {
              progressUpdateCallback('Pre-Processing', pct.toFixed(0));
            }
            if (window.EXCHANGE_UPLOAD_CANCELED) {
              readerMap.forEach((readerBlock, reader) => reader.abort());
              reject(new Error('Canceled'));
            }
            lastPct = pct;
          }
        }
      }

      function onLoad(data: any, level: any) {
        const reader = data.target;
        const off = readerMap.get(reader);
        // Time based queue reording if we need it, the hash must be processed sequentially...
        if (off !== lastOffset) {
          setTimeout(() => onLoad(data, level + 1), 10);
        } else {
          if (isVideo && !ignoreVideoCalculations) {
            const myBuf = data.target.result;
            myBuf.fileStart = off;
            try {
              mp4boxfile.appendBuffer(myBuf);
            } catch (e) { /** caught error */ }
          }

          hash.update(CryptoJS.lib.WordArray.create(data.target.result));
          processed += data.total;
          if (processed >= sz) {
            const sha1 = hash.finalize().toString();
            if (isVideo && fileInfo && mp4boxfile.moov && !ignoreVideoCalculations) {
              mp4boxfile.flush();
              const samps = mp4boxfile.moov.traks[0].samples;
              // Get the largest GOP size
              for (let i = 0; i < samps.length; i += 1) {
                const samp = samps[i];
                if (samp.is_sync) {
                  gopSize = runningSamps;
                  if (gopSize > maxGop) {
                    maxGop = gopSize;
                  }
                  runningSamps = 1;
                } else {
                  runningSamps += 1;
                }
              }
              // Now, walk the samples modulus GOP and see if they are all keyframes...
              if (maxGop === 0) {
                ok = false;
              } else {
                for (let i = 0; i < samps.length; i += maxGop) {
                  const samp = samps[i];
                  if (!samp.is_sync) {
                    ok = false;
                    break;
                  }
                }
              }

              let [videoTrack] = fileInfo.videoTracks;
              if (!videoTrack) [videoTrack] = fileInfo.tracks;
              let width = videoTrack.video?.width;
              let height = videoTrack.video?.height;
              if (!width) width = videoTrack.track_width;
              if (!height) height = videoTrack.track_height;

              // Calculate FPS...
              const calcFps = (videoTrack.timescale / (videoTrack.samples_duration / videoTrack.nb_samples));
              // Calculate bitrate...
              const video_bitrate = Math.ceil((videoTrack.bitrate / 1024));
              const file_bitrate = Math.ceil(sz * 8 / (videoTrack.duration / videoTrack.timescale) / 1024);
              resolve({
                width,
                height,
                bitrate: Math.max(video_bitrate, file_bitrate),
                gop: maxGop,
                fixedGop: ok,
                fps: calcFps,
                sha1,
                hasAudio: !!fileInfo.audioTracks.length,
                mediaType: GetVideoMediaType(width, height, calcFps.toString()),
              });
            } else {
              resolve({
                sha1,
              });
            }
          }
          lastOffset = off + data.total;
          readerMap.delete(reader);

          // Reuse reader for next block (if needed).
          if (nextReaderBlock < sz) {
            readerMap.set(reader, nextReaderBlock);
            reader.onload = (d: any) => {
              onLoad(d, 1);
            };
            retryRead(fileStream, nextReaderBlock, reader);
            nextReaderBlock += block;
          }
        }
      }

      // We only create 5 readers at a time.
      for (offset = 0; offset < block * maxReaders; offset += block) {
        const reader = new window.FileReader();
        readerMap.set(reader, offset);
        reader.onload = (data) => {
          onLoad(data, 1);
        };
        retryRead(fileStream, offset, reader);
        nextReaderBlock += block;
      }
    } catch (e) { reject(e); }
  });
}
